export default (languagePackUrl) => new Promise(done => jQuery.get(languagePackUrl).then((languagePacks) => done(languagePacks)))